import * as React from 'react';
import styled from 'styled-components';

import * as colors from '../../shared/colors';
import TaskIcon from '../../shared/components/icons/TaskIcon';
import { IExampleTask } from './ExamplesModal';

interface IProps {
    task: IExampleTask;
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0.1rem 0;
    padding: 0.2rem 0.2rem;
    border: 2px solid ${colors.primaryColor};
    border-radius: 1rem;
    font-size: 0.85rem;
    > * {
        margin: 0 0.2rem;
    }
`;

const IconCol = styled.div`
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    svg {
        width: 50px;
        height: 50px;
    }

`;

const NameCol = styled.div`
    flex-grow: 1;
    flex-basis: 0;
    h4 {
        font-size: 1.1rem;
        margin: 0;
    }
`;

function ExampleTask({ task }: IProps): JSX.Element {
    return <Wrapper>
        <IconCol>
            <TaskIcon icon={task.icon} />
        </IconCol>
        <NameCol>
            <h4>{task.shortTitle}</h4>
            <div>{task.shortDescription}</div>
        </NameCol>
    </Wrapper>;
}

export default ExampleTask;
